import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {
    view: boolean;
}

const ManageTheSesDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    return (
        <ManageBooksDetail
            view={view}
            library_category_name={ELibraryCategory.THESIS}
            menu_name={t("จัดการวิทยานิพนธ์")}
            menu_name_detail={t("เพิ่มวิทยานิพนธ์")}
            menu_path_name={routeName.e_library.manage_the_ses}
        />
    )
}

export default ManageTheSesDetail